import { ErrorParser } from "../ErrorParser";

/**
 * Ej: 'The url {{link}} has an error'
 */
export class UrlConErrorParser implements ErrorParser {

    public puedeLeerError(errors: string[]): boolean {
        if (!Array.isArray(errors)) {
            return false;
        }
        return errors.some(valor => valor.includes("The url") && valor.includes("has an error"));
    }

    public traducir(errors: string[]): string {
        return errors[0].replace("The url", "La url").replace("has an error", "tiene un error");
    }

}
